<template>
  <SoRadioGroup v-model="value" :items="items" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useReviewPaymentStore } from "@/stores/reviewPayment"
  import SoRadioGroup from "@/components/formControls/SoRadioGroup.vue"
  import { ChangePaymentChoice } from "@/constants/finance"

  const ChangePaymentChoiceItems = [
    {
      text: "Change of circumstance",
      value: ChangePaymentChoice.Circumstance,
    },
    {
      text: "Financial difficulty - can’t pay suggested amount",
      value: ChangePaymentChoice.FinancialDifficulty,
    },
    {
      text: "Customer wants to recalculate",
      value: ChangePaymentChoice.CustomerRecalculate,
    },
  ]

  export default defineComponent({
    components: {
      SoRadioGroup,
    },
    data() {
      return {
        reviewPayment: useReviewPaymentStore(),
        items: ChangePaymentChoiceItems,
      }
    },
    computed: {
      value: {
        get() {
          return this.reviewPayment.reason
        },
        set(value) {
          this.reviewPayment.reason = value
        },
      },
    },
    watch: {
      value(val) {
        if (val !== ChangePaymentChoice.Circumstance) {
          this.reviewPayment.selectedEstimates = []
        }
      },
    },
  })
</script>
